import { Component, Input, input, OnInit } from '@angular/core';
import { CommentService } from '@arkius/shared-api';
import { ModalController, NavController } from '@ionic/angular';
import { take } from 'rxjs';
import { ModerateModalComponent } from '../moderate-modal/moderate-modal.component';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-lib-moderate-reply-modal',
  templateUrl: './moderate-reply-modal.component.html',
  styleUrls: ['./moderate-reply-modal.component.css'],
})
export class ModerateReplyModalComponent implements OnInit {
  @Input() item: any;

  constructor(
    private commentService: CommentService,
    private modalCtrl: ModalController,
    private navController: NavController,
  ) {}

  ngOnInit() {
    environment.log('inside modal item', this.item);
  }

  moderateReplyDownvote() {
    this.commentService
      .apiV5CommentCommentReplyIdModerateDownvotePost(this.item.commentReplyId)
      .pipe(take(1))
      .subscribe({
        next: async () => {
          await this.modalCtrl.dismiss();
          await this.displayModerateReplyThankYouModal(); // Show the modal and wait for it to dismiss
          this.navController.back(); // Navigate back after the modal is dismissed
        },
        error: (error) => {
          environment.log(error);
        },
      });
  }
  moderateReplyUpvote() {
    this.commentService
      .apiV5CommentCommentReplyIdModerateUpvotePost(this.item.commentReplyId)
      .pipe(take(1))
      .subscribe({
        next: async () => {
          await this.modalCtrl.dismiss();
          await this.displayModerateReplyThankYouModal(); // Show the modal and wait for it to dismiss
          this.navController.back(); // Navigate back after the modal is dismissed
        },
        error: (error) => {
          environment.log(error);
        },
      });
  }

  async displayModerateReplyThankYouModal() {
    const modal = await this.modalCtrl.create({
      component: ModerateModalComponent,
    });

    const modalElement = modal.shadowRoot?.querySelector(
      '.modal-wrapper',
    ) as HTMLElement;
    if (modalElement) {
      modalElement.style.width = '90%';
      modalElement.style.borderRadius = '8px';
    }

    // Present the modal and wait for it to be dismissed
    await modal.present();
    await modal.onDidDismiss(); // Wait for the modal to be dismissed
  }
}
